<template>
  <div v-loading="loading">
    <slot name="header"></slot>

    <el-form label-width="100px" class="form" @submit.native.prevent>
      <el-row>
        <el-col :span="12">
          <el-form-item label="身份证号码">
            <el-input
              v-model="idCard"
              maxlength="18"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号">
            <el-input
              v-model="mobile"
              maxlength="11"
              show-word-limit
            ></el-input>
            <b>此身份证的专家，入库的时候使用的手机号</b>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <div v-show="searched">
      <el-card v-if="hasMavin">
        <div slot="header">
          <span>基本信息</span>
        </div>
        <el-row>
          <el-col :span="24">
            <el-descriptions :column="2" :contentStyle="{ height: '35px' }">
              <el-descriptions-item label="专家编号">
                {{ info.mavinNo }}
              </el-descriptions-item>
              <el-descriptions-item label="姓名">
                {{ info.mavinName }}
              </el-descriptions-item>
              <el-descriptions-item label="身份证号码">
                {{ info.idCard }}
              </el-descriptions-item>
              <el-descriptions-item label="手机号">
                {{ info.mobile }}
              </el-descriptions-item>
              <el-descriptions-item label="基层工作单位">
                {{ info.deptName }}
              </el-descriptions-item>
              <el-descriptions-item label="可评审专业1">
                {{ info.allSpeName1 }}
              </el-descriptions-item>
              <el-descriptions-item label="可评审专业2">
                {{ info.allSpeName2 }}
              </el-descriptions-item>
              <el-descriptions-item label="可评审专业3">
                {{ info.allSpeName3 }}
              </el-descriptions-item>
              <el-descriptions-item label="状态" span="1">
                {{ info.stateName }}
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
          <el-col :span="24" class="text-center">
            <el-button @click="handleEdit">我要编辑</el-button>
            <el-button
              type="primary"
              @click="handleSubmit"
              v-show="info.putable"
            >
              选择入库
            </el-button>
          </el-col>
        </el-row>
      </el-card>

      <el-card v-else>
        <div slot="header" class="clearfix">
          <span>操作提示</span>
        </div>
        <div class="search-no text-center">
          <slot
            name="footer"
            v-bind:idCard="idCard"
            v-bind:mobile="mobile"
          ></slot>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getPrecise, savePrecise } from '@/api/boards/mavin.js';

export default {
  data() {
    return {
      loading: false,
      searched: false,
      hasMavin: false,
      idCard: '',
      mobile: '',
      info: {}
    };
  },
  methods: {
    onSearch() {
      this.searched = false;
      if (!this.idCard || this.idCard.length < 18) {
        this.msgError('身份证号码必须为18位');
        return;
      }
      if (!this.mobile || this.mobile.length < 11) {
        this.msgError('手机号必须为11位');
        return;
      }
      this.loading = true;
      getPrecise(this.idCard, this.mobile)
        .then(res => {
          this.searched = true;
          if (res && res.mavinNo) {
            this.hasMavin = true;
            this.info = res;
          } else {
            this.hasMavin = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleEdit() {
      if (this.info && this.info.mavinEid) {
        window.open(`/mavin/built/${this.info.mavinEid}`, 'handleMavinAdd');
      } else {
        this.msgError('请您先查询！');
      }
    },
    handleSubmit() {
      this.loading = true;
      savePrecise(this.idCard)
        .then(res => {
          this.msgSuccess('入库成功！');
          this.info.putable = false;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  padding-top: 30px;
}
.search-no {
  font-size: 14px;
}
</style>
